import React from 'react';
import { useIsMobile } from '../../hooks/useMediaQuery';
import { useMealTargetsStep } from '../../hooks/useMealTargetsStep';
import type { BuilderDerived, Dispatch } from '../../hooks/useDietPlanBuilder';
import type { Plan, Template } from '../../types';
import { MealTargetsStepDesktop } from './MealTargetsStepDesktop';
import { MealTargetsStepMobile } from './MealTargetsStepMobile';

export function MealTargetsStep({
  plan,
  derived,
  tpl,
  dispatch,
  onEditGoals,
}: {
  plan: Plan;
  derived: NonNullable<BuilderDerived>;
  tpl: Template | null;
  dispatch: Dispatch;
  onEditGoals: () => void;
}) {
  const t = useMealTargetsStep(plan, derived, tpl, dispatch);
  const isMobile = useIsMobile();
  return isMobile
    ? <MealTargetsStepMobile planKcal={plan.kcal} t={t} onEditGoals={onEditGoals} />
    : <MealTargetsStepDesktop planKcal={plan.kcal} t={t} onEditGoals={onEditGoals} />;
}
